import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './pmf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Poisson distribution probability mass function (PMF).
*
* @module @stdlib/stats/base/dists/poisson/pmf
*
* @example
* var pmf = require( '@stdlib/stats/base/dists/poisson/pmf' );
*
* var y = pmf( 4.0, 3.0 );
* // returns ~0.168
*
* y = pmf( 1.0, 3.0 );
* // returns ~0.149
*
* y = pmf( -1.0, 2.0 );
* // returns 0.0
*
* var mypmf = pmf.factory( 1.0 );
* y = mypmf( 3.0 );
* // returns ~0.061
*
* y = mypmf( 1.0 );
* // returns ~0.368
*/

// MODULES //
var setReadOnly = __var_0__;
var pmf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( pmf, 'factory', factory );


// EXPORTS //
export default pmf;
